import { ApiType } from "./Types";
import { env } from "../constants";

/**
 * A function to generate the correct URL for API calls
 * @param apiType - The type of API URL needed
 * @returns - A URL to make an API call, factoring in the current ENV
 */
export const getUrl = (apiType: ApiType): string => {
  const baseUrl = `${env.wnrApi.url}${env.wnrApi.path}`;
  const endpointMap: { [key in ApiType]: string } = {
    [ApiType.DEPLOYMENT_STATUS]: "/deployment-status",
    [ApiType.TERMINAL]: "/master/terminals",
    [ApiType.VALIDATE_OKTA_TOKEN]: "/auth/tokens/verification",
    [ApiType.EXCEPTIONS_LIST]: "/exception",
    [ApiType.OVERAGE_CREATE]: "/overages",
    [ApiType.MASTER_RECORDS]: "/master/records",
    [ApiType.OVERAGE_FILTER_MASTER_USER]: "/master/users",
    [ApiType.EXCEPTION_ASSIGN]: "/exception/assignments",
    [ApiType.DASHBOARD_KRA]: "/dashboard/summaries",
    [ApiType.EXCEPTION_DETAILS]: "/exception",
    [ApiType.OVERAGE_ENTRY_DETAILS]: "/overages/edit",
    [ApiType.PRO_IMAGES]: "/files/get",
    [ApiType.MANIFEST_DETAILS]: "/manifests",
    [ApiType.MANIFEST_PRO_DETAILS]: "/manifests-pro",
    [ApiType.SEND_APB_MAIL]: "/exception/:osdId/apb/send",
    [ApiType.SEND_MAIL]: "/email/:osdNumber/send",
    [ApiType.MASTER_PRO_NUMBER]: "/master/pro-numbers",
    [ApiType.MASTER_OSD_NUMBER]: "/master/osd-numbers",
    [ApiType.COMMODITY_TYPE_MASTER]: "/master/commodity-types",
    [ApiType.EXCEPTION_CODE_MASTER]: "/master/exception-codes",
    [ApiType.CHECK_PRO]: "/pro",
    [ApiType.OVERAGE_UPDATE]: "/overages",
    [ApiType.SAVE_OR_SUBMIT_INVESTIGATION]: "/overages",
    [ApiType.LOCATION_MASTER]: "/master/locations",
    [ApiType.UPLOAD_FILE]: "/files/upload",
    [ApiType.DOC_TYPE]: "/files/docTypes",
    [ApiType.PRINT]: "/overages/:osdNumber/print",
    [ApiType.SHORTAGE_ENTRY_CREATE]: "/all-short",
    [ApiType.AS_ENTRY_DETAILS]: "/all-short/edit",
    [ApiType.DS_ENTRY_DETAILS]: "/delivered-short/edit",
    [ApiType.SHORTAGE_INVESTIGATION]: "/shortages/:osdNumber/investigation/:day/:action",
    [ApiType.AS_ENTRY_UPDATE]: "/all-short",
    [ApiType.DS_ENTRY_UPDATE]: "/delivered-short",
    [ApiType.LOGGLY_LOG]: "/system/log",
    [ApiType.SAVE_OR_SUBMIT_DS_INVESTIGATION]: "/delivered-short/:osdId/investigation",
    [ApiType.BNF_EDIT_VIEW]: "/bill-no-freight/edit",
    [ApiType.BNF_FOLLOWUP]: "/bill-no-freight/:osdNumber/followup",
    [ApiType.REFUSAL_ENTRY_DETAILS]: "/refusal/edit",
    [ApiType.REFUSAL_ENTRY_UPDATE]: "/refusal",
    [ApiType.REFUSAL_FOLLOWUP]: "/refusal/:osdNumber/workflow",
    [ApiType.SEND_DISPOSITION_DATA]: "/exception/:osdNumber/disposition/data",
    [ApiType.ON_HAND_VIEW]: "/on-hand-delivery/edit",
    [ApiType.ON_HAND_ENTRY_CREATE]: "/on-hand-delivery",
    [ApiType.ON_HAND_INVESTIGATION]: "/on-hand-delivery/:osdNumber/investigation",
    [ApiType.ON_HAND_FOLLOWUP]: "/on-hand-delivery/:osdNumber/followup",
    [ApiType.UPDATE_EXCEPTION_LOCATION]: "/overages/:osdNumber/datatable",
    [ApiType.GET_MISDELIVERY]: "/mis-delivery",
    [ApiType.MISDELIVERY_CREATE]: "/mis-delivery",
    [ApiType.MSD_VIEW]: "/mis-delivery/edit",
    [ApiType.MSD_NOTES]: "/mis-delivery/notes",
    [ApiType.MSD_IVESTIGATION]: "/mis-delivery",
    [ApiType.PICKUP_DETAILS]: "/pickup/:pickupNumber",
    [ApiType.MISDELIVERY_BOL]: "/mis-delivery/:osdNumber/bol",
    [ApiType.MISDELIVERY_VALIDATE_BOL_PRO]: "/mis-delivery/validate-bol-pro",
    [ApiType.UN_NA_NUMBERS]: "/master/un-na-numbers",
    [ApiType.CLEARING_CODES]: "/master/clearing-codes",
    [ApiType.LOGOUT]: "/user/logout",

  };

  return endpointMap[apiType] ? `${baseUrl}${endpointMap[apiType]}` : "http://localhost:1337";
};
